import { RotateCw } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/Button";
import { EmptyState, ErrorState, Spinner } from "@/components/states";
import { useHistory } from "@/hooks/useHistory";
import { filtersSummary } from "@/lib/filters";
import { useHuntStore } from "@/stores/hunt";
import type { SearchHistoryItem } from "@/types";

export function History() {
  const { data, isLoading, isError } = useHistory();
  const navigate = useNavigate();
  const setReplay = useHuntStore((s) => s.setReplay);

  function rerun(h: SearchHistoryItem) {
    setReplay(h.preset ? { preset: h.preset, filters: h.filters } : { query: h.query, filters: h.filters });
    navigate("/hunt");
  }

  return (
    <main className="mx-auto w-full max-w-4xl px-6 py-6">
      <h1 className="mb-4 text-lg font-semibold text-ink-1">История поисков</h1>
      {isLoading && <Spinner />}
      {isError && <ErrorState>Не удалось загрузить историю.</ErrorState>}
      {data && data.length === 0 && <EmptyState>Пока пусто — сделай первый поиск.</EmptyState>}
      <div className="space-y-2">
        {data?.map((h) => {
          const summary = filtersSummary(h.filters);
          return (
            <div
              key={h.id}
              className="flex items-center justify-between gap-3 rounded-lg border border-line bg-bg-1 px-4 py-3"
            >
              <div className="min-w-0">
                <div className="truncate font-medium text-ink-1">{h.query || "(пусто)"}</div>
                <div className="truncate text-xs text-ink-3">
                  {summary && `${summary} · `}
                  {h.result_count} рез. · {new Date(h.created_at).toLocaleString("ru")}
                </div>
              </div>
              <Button variant="ghost" onClick={() => rerun(h)}>
                <RotateCw size={14} /> Повторить
              </Button>
            </div>
          );
        })}
      </div>
    </main>
  );
}
